import React, { Component } from 'react';
import authService from './../api-authorization/AuthorizeService'
import { ConfigMenu } from './../ConfigMenu'
import ReactRegionSelect from 'react-region-select';
import {FormattedMessage} from 'react-intl';
import SideNav, { NavItem, NavIcon, NavText } from '@trendmicro/react-sidenav';
import ReactQuill from 'react-quill';
import Popup from './../popup/reactjs-popup.cjs.development';
import 'reactjs-popup/dist/index.css';

export class ConfigResources extends Component {
  constructor(props) {
    super(props);
    var curDate = new Date();
    curDate.setHours(0,0,0,0);
    this.state = {
      resources: [],
      services: [],
      service: null,
      loading: true,
      filters: [],
      profiles: [],
      collapsed: true,
      companyId: parseInt(this.props.match.params.companyId) || 0,
      resource: null
    };
    this.handleNew = this.handleNew.bind(this);
    this.handleSave = this.handleSave.bind(this);
    this.handleNewGroup = this.handleNewGroup.bind(this);
    this.onRegionChange = this.onRegionChange.bind(this);
    //this.toggleNavbar = this.toggleNavbar.bind(this);
  }

  componentDidMount() {
    if (this.state.companyId === 0)
      this.populateCompaniesData();
    else {
      this.populateResourcesData(this.state.companyId);
      this.populateFiltersData();
    }
  }

  selectResource(resource) {
    this.setState(prevState => ({...prevState, resource: resource, regions: resource.locationX!==null?[{x:resource.locationX, y:resource.locationY, width:resource.locationWidth, height:resource.locationHeight, data: {index: 0}, isChanging: false, new: false}]:[]}));
    this.populateServicesData(this.state.companyId);
  }

  handleNew() {
    this.setState(prevState => ({...prevState, resource: { id: 0, count: 1, images: [], companyImages:[], params: [], locationX: null }}));
  }

  async handleSaveFilter() {
  }

  async handleSave() {
    if (!this.state.resource.name || this.state.resource.name === '')
      return;
    const token = await authService.getAccessToken();
    var headers = !token ? {} : { 'Authorization': `Bearer ${token}` };
    const response = await fetch(`{{mainApiUrl}}api/companies/${this.state.companyId}/resource`, {
      method: "POST",
      headers: {
        ...headers,
        'Accept': 'application/json, text/plain',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(this.state.resource)
    });
    const data = await response.json();
    var resources = this.state.resources;
    for (var i = 0; i < resources.length; i++)
    {
      if (resources[i].id === this.state.resource?.id)
      {
        resources[i] = this.state.resource;
        break;
      }
    }
    if (i === resources.length)
      resources.push(data);
    this.setState(prevState => ({...prevState, resource: data}));
    this.setState(prevState => ({...prevState, resources: resources}));
  }

  async handleNewGroup() {
    if (!this.state.newgroupname || this.state.newgroupname === '')
      return;
    const token = await authService.getAccessToken();
    var headers = !token ? {} : { 'Authorization': `Bearer ${token}` };
    const response = await fetch(`{{mainApiUrl}}api/companies/resourceparamgroup`, {
      method: "POST",
      headers: {
        ...headers,
        'Accept': 'application/json, text/plain',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({name: this.state.newgroupname, createdCompanyId: this.state.companyId})
    });
    const data = await response.json();
    this.setState(prevState => ({...prevState, newgroupname: undefined, filters: [...prevState.filters, data]}));
  }

  async saveGroupValue(groupId) {
    if (!this.state.newgroupvalue || this.state.newgroupvalue === '')
      return;
    const token = await authService.getAccessToken();
    var headers = !token ? {} : { 'Authorization': `Bearer ${token}` };
    const response = await fetch(`{{mainApiUrl}}api/companies/resourceparam/${groupId}`, {
      method: "POST",
      headers: {
        ...headers,
        'Accept': 'application/json, text/plain',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({name: this.state.newgroupvalue, createdCompanyId: this.state.companyId})
    });
    const data = await response.json();
    var filters = this.state.filters;
    filters.filter(f => f.id === groupId)[0].items.push(data);
    this.setState(prevState => ({...prevState, curparamgroup: undefined, newgroupvalue: undefined, filters: filters}));
  }

  selectService(service) {
    this.setState(prevState => ({...prevState, service: service}));
  }

  selectParamService(service) {
    this.setState(prevState => ({...prevState, paramservice: service}));
  }

  addFilter(id, groupId) {
    var params = this.state.resource.params;
    if (params.includes(id)) {
        params = params.filter(f => f !== id);
        this.changeResourceResourceParam(id, true);
    }
    else {
      if (groupId > 0) {
        var alreadySelected = this.state.filters.filter(f => f.id === groupId)[0].items.filter(f => params.includes(f.id));
        if (alreadySelected.length > 0) {
          params = params.filter(f => f !== alreadySelected[0].id);
          this.changeResourceResourceParam(alreadySelected[0].id, true);
        }
      }
      params.push(id);
      this.changeResourceResourceParam(id, false);
    }
    const res = this.state.resources;
    res.filter(r => r.id === this.state.resource?.id)[0].params = params;
    this.setState(prevState => ({...prevState, resource: { ...prevState.resource, params: params}}));
  }

  async changeResourceResourceParam(id, remove) {
    const token = await authService.getAccessToken();
    var headers = !token ? {} : { 'Authorization': `Bearer ${token}` };
    const response = await fetch(`{{mainApiUrl}}api/companies/resourceresourceparam/${this.state.companyId}/${this.state.resource.id}/${id}`, {
      method: remove ? "DELETE" : "POST",
      headers: {
        ...headers,
        'Accept': 'application/json, text/plain',
        'Content-Type': 'application/json'
      }
    });
    await response.json();
  }

  async assignResource(service) {
    service.assigned = !service.assigned;
    const token = await authService.getAccessToken();
    var headers = !token ? {} : { 'Authorization': `Bearer ${token}` };
    const response = await fetch(`{{mainApiUrl}}api/companies/${this.state.companyId}/${this.state.resource.id}/service`, {
      method: "POST",
      headers: {
        ...headers,
        'Accept': 'application/json, text/plain',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(service)
    });
    await response.json();
    this.setState(prevState => ({...prevState, services: [...prevState.services]}));
  }

  async addFile(event) {
    var formData = new FormData();
    formData.append("file", event.target.files[0]);

    const token = await authService.getAccessToken();
    var headers = !token ? {} : { 'Authorization': `Bearer ${token}` };
    const response = await fetch(`{{mainApiUrl}}api/companies/${this.state.companyId}/${this.state.resource.id}/image`, {
      method: 'POST',
      headers: {
        ...headers,
        'Accept': 'application/json, text/plain'
      },
      body: formData
    });
    const data = await response.json();
    this.setState(prevState => ({...prevState, resource: {...prevState.resource, images: [data]}}));
  }

  onRegionChange(val) {
    console.log(val);
    this.setState(prevState => ({...prevState, resource: {...prevState.resource, locationX: val[0].x, locationY: val[0].y, locationWidth: val[0].width, locationHeight: val[0].height}, regions: val}));
  }

  updateResourceLocation(evt) {
    const val = evt.target.value;
    //this.setState(prevState => ({...prevState, company: {...prevState.company, locationX: parseFloat(val.split(',')[0]), locationY: parseFloat(val.split(',')[1])}}));
  }

  /*toggleNavbar () {
    this.setState({
      collapsed: !this.state.collapsed
    });
  }*/

  renderRightPanel() {
    return (
      <SideNav className="rightpanel">
        <SideNav.Toggle className="righttoggle"/>
        <SideNav.Nav className="rightcontainer" selected={this.props.selected}>
            <table class="table table-striped navbar-nav flex-grow" aria-labelledby="tabelLabel"><tbody>
              {this.state.resources.map(resource =>
                <tr><td key={resource.id} onClick={() => this.selectResource(resource)} class={this.state.resource.id === resource.id?'react-calendar__tile--active':''}>
                  {resource.name}</td></tr>
              )}
            </tbody></table>
        </SideNav.Nav>
      </SideNav>
    );
  }

  renderResourcesTable() {
    return (
        <div class="tabledivbig">
        <div class="tabledivbtn">

          <table className='table table-striped' aria-labelledby="tabelLabel">
            <thead>
              <tr>
                <th>Id</th>
                <th>Name</th>
                <th>Count</th>
              </tr>
            </thead>
            <tbody>
              {this.state.resources.map(resource =>
                <tr key={resource.id} onClick={() => this.selectResource(resource)} class={this.state.resource?.id === resource.id?'react-calendar__tile--active':''}>
                  <td>{resource.id}</td>
                  <td>{resource.name}</td>
                  <td>{resource.count}</td>
                </tr>
              )}
            </tbody>
          </table>

        </div>
        <input style={{marginTop: "5px"}} class="btn btn-primary" disabled={this.state.resource?.id===0} type="button" value="New" id="Button_New" onClick={this.handleNew}/>
        </div>
    );
  }
  renderResourcesParams() {
    const regionStyle = {
      background: "rgba(0, 0, 255, 0.5)",
      zIndex: 99
    };
    return (
      <div>
        <div class="form-group">
          <label for="Input_ResourceName">Resource name</label>
          <input class="form-control" type="text" id="Input_ResourceName" name="Input.ResourceName"
            value={this.state.resource.name !== undefined ? this.state.resource.name : ''}
            onChange={evt => {const val = evt.target.value; this.setState(prevState => ({...prevState, resource: {...prevState.resource, name: val}}));}}
          />
        </div>
        <div class="form-group">
          <label for="Input_ResourceDescription">Resource long description</label>
          <ReactQuill class="form-control" id="Input_ResourceDescription" name="Input.ResourceDescription"
            value={this.state.resource.description !== undefined ? this.state.resource.description : ''}
            onChange={val => {this.setState(prevState => ({...prevState, resource: {...prevState.resource, description: val}}));}}
          />
        </div>
        <div class="form-group">
          <label for="Input_ResourceCount">Number of instances</label>
          <input class="form-control" type="text" id="Input_ResourceCount" name="Input.ResourceCount"
            value={this.state.resource.count !== undefined ? this.state.resource.count : '1'}
            onChange={evt => {const val = evt.target.value; this.setState(prevState => ({...prevState, resource: {...prevState.resource, count: val}}));}}
          />
        </div>
        <div class="form-group">
          <label for="Input_BookingProfile">Resource booking profile</label>
          <select class="form-control" id="Input_BookingProfile" name="Input.BookingProfile"
            value={this.state.resource.profileId ? this.state.resource.profileId.toString() : ''}
            onChange={evt => {const val = evt.target.value; this.setState(prevState => ({...prevState, resource: {...prevState.resource, profileId: parseInt(val)}}));}}>
              <option value="0"></option>
              {this.state.profiles.map(profile => <option value={profile.id}>{profile.name}</option>)}
          </select>
        </div>
        {this.state.resource.id > 0 ? (
          <><div class="form-group">
            <div>Photo</div>
            <img src={"{{mainApiUrl}}"+this.state.resource.images[0]} alt="" class="schemecomp"/>
          </div>
          <div class="tablediv">
            <label for="file-upload" class="btn btn-primary">
              <i class="fa fa-cloud-upload"></i> Upload photo
            </label>
            <input id="file-upload" onChange={this.addFile.bind(this)} type="file"/>
          </div></>
        ) : <></>}
        <div class="form-group">
          <label for="Input_ResourceMap">Resource map location</label>
          <select class="form-control" id="Input_ResourceMap" name="Input.ResourceMap"
            value={this.state.resource.mapId ? this.state.resource.mapId.toString() : ''}
            onChange={evt => {const val = evt.target.value; this.setState(prevState => ({...prevState, resource: {...prevState.resource, mapId: parseInt(val)}}));}}>
              <option value="0"></option>
              {this.state.resource.companyImages.map((img, i) => <option value={(i+1).toString()}>{img}</option>)}
          </select>
        </div>
        <div>
          <label for="Input_ResourceLoc">Resource location</label>
          <input disabled class="form-control" type="text" id="Input_ResourceLoc" name="Input.ResourceLoc" value={this.state.resource.locationX !== null ? this.state.resource.locationX.toString()+','+this.state.resource.locationX.toString()+','+this.state.resource.locationWidth.toString()+','+this.state.resource.locationHeight.toString() : ''} onChange={evt => this.updateResourceLocation(evt)}/>
          {this.state.resource.mapId && this.state.resource.mapId > 0 ? (
            <ReactRegionSelect
              maxRegions={1}
              regions={this.state.regions}
              regionStyle={regionStyle}
              onChange={this.onRegionChange}>
              <img src={"{{mainApiUrl}}"+this.state.resource.companyImages[parseInt(this.state.resource.mapId) - 1]} class="schemeimg"/>
            </ReactRegionSelect>
          ) : <></>}
        </div>
        <div class="tablediv">
          <input class="btn btn-primary" type="button" value={this.state.resource.id===0?"Create":"Save"} id="Button_Save" onClick={this.handleSave}/>
        </div>
      </div>
    );
  }

  renderServicesTable() {
    return (
      <><div class="tablediv">

      <div>Assign services and override prices</div>
      <table className='table table-striped' aria-labelledby="tabelLabel">
        <thead>
          <tr>
            <th>Id</th>
            <th>Name</th>
            <th>Assigned</th>
            <th>Price</th>
            <th>MinTime</th>
            <th>MaxTime</th>
            <th>Editable</th>
          </tr>
        </thead>
        <tbody>
          {this.state.services.map(service =>
            <tr key={service.id} onClick={() => this.selectService(service)} class={this.state.service?.id === service.id?'react-calendar__tile--active':''}>
              <td>{service.id}</td>
              <td>{service.name}</td>
              <td onClick={() => this.assignResource(service)}>{service.assigned ? '+' : ''}</td>
              <td>{service.price}</td>
              <td>{service.minTime}</td>
              <td>{service.maxTime}</td>
              <td>{service.timeEditable ? '+' : ''}</td>
            </tr>
          )}
        </tbody>
      </table>

      </div>

              {this.state.service === null || !this.state.service.assigned?<></>:
        <><div class="form-group">
          <label for="Input_ServiceName">Service name</label>
          <input class="form-control" disabled={true} type="text" id="Input_ServiceName" name="Input.ServiceName"
            value={this.state.service.name ? this.state.service.name : ''}
            onChange={evt => {const val = evt.target.value; this.setState(prevState => ({...prevState, service: {...prevState.service, name: val}}));}}/>
        </div>
        <div class="form-group">
          <label for="Input_ServicePrice">Service price</label>
          <input class="form-control" type="text" id="Input_ServicePrice" name="Input.ServicePrice"
            value={this.state.service.price !== undefined ? this.state.service.price : '0'}
            onChange={evt => {const val = evt.target.value; this.setState(prevState => ({...prevState, service: {...prevState.service, price: val}}));}}
          />
        </div>
        <div class="form-group">
          <label for="Input_ServiceMinTime">Service minimum duration in hours</label>
          <input class="form-control" type="text" id="Input_ServiceMinTime" name="Input.ServiceMinTime"
            value={this.state.service.minTime !== undefined ? this.state.service.minTime : '0'}
            onChange={evt => {const val = evt.target.value; this.setState(prevState => ({...prevState, service: {...prevState.service, minTime: val}}));}}
          />
        </div>
        <div class="form-group">
          <label for="Input_ServiceMaxTime">Service maximum duration in hours</label>
          <input class="form-control" type="text" id="Input_ServiceMaxTime" name="Input.ServiceMaxTime"
            value={this.state.service.maxTime !== undefined ? this.state.service.maxTime : '8760'}
            onChange={evt => {const val = evt.target.value; this.setState(prevState => ({...prevState, service: {...prevState.service, maxTime: val}}));}}
          />
        </div>
        <div class="form-group">
          <label for="Input_BookingInterval">Service booking interval</label>
          <select class="form-control" id="Input_BookingInterval" name="Input.BookingInterval"
            value={this.state.service.bookingInterval ? this.state.service.bookingInterval.toString() : ''}
            onChange={evt => {const val = evt.target.value; this.setState(prevState => ({...prevState, service: {...prevState.service, bookingInterval: val}}));}}>
              <option value="1">1 min</option>
              <option value="2">5 min</option>
              <option value="3">1 hour</option>
              <option value="4">1 day</option>
          </select>
        </div>
        <div class="form-group">
          <label for="Input_PartialBooking">Partial booking settings</label>
          <select class="form-control" id="Input_PartialBooking" name="Input.PartialBooking"
            value={this.state.service.partialBooking ? this.state.service.partialBooking.toString() : 'null'}
            onChange={evt => {const val = evt.target.value; this.setState(prevState => ({...prevState, service: {...prevState.service, partialBooking: val === 'null' ? null : val}}));}}>
              <option value="null">Off</option>
              <option value="2">2 members</option>
              <option value="3">3 members</option>
              <option value="4">4 members</option>
              <option value="5">5 members</option>
              <option value="6">6 members</option>
              <option value="7">7 members</option>
              <option value="8">8 members</option>
              <option value="9">9 members</option>
              <option value="10">10 members</option>
          </select>
        </div>
        <div class="form-group">
          <label for="Input_Prepayment">Prepayment amount</label>
          <input class="form-control" type="text" id="Input_Prepayment" name="Input.Prepayment"
            value={this.state.service.prepayment !== undefined ? this.state.service.prepayment : '0'}
            onChange={evt => {const val = evt.target.value; this.setState(prevState => ({...prevState, service: {...prevState.service, prepayment: val}}));}}
          />
        </div>
        <div class="form-group">
          <label for="Input_Cancelation">Cancelation is possible before the scheduled time in hours</label>
          <input class="form-control" type="text" id="Input_Cancelation" name="Input.Cancelation"
            value={this.state.service.cancelation !== undefined ? this.state.service.cancelation : '0'}
            onChange={evt => {const val = evt.target.value; this.setState(prevState => ({...prevState, service: {...prevState.service, cancelation: val}}));}}
          />
        </div>
        <input style={{marginTop: "5px"}} class="btn btn-primary" type="button" value="Save" id="Button_Save" onClick={() => this.handleSave(this.state.service)}/>
        </>}
</>
    );
  }

  renderParamOptions(param, val) {
    return (
      <>
      <h4>{param.name} ({val.name})</h4>
        <div>
          <input style={{margin: "5px 5px 0 0"}} class="form-check-input" type="checkbox" id="Input_Optional" name="Input.Optional"
            checked={val.optional !== undefined ? val.optional : false}
            onChange={evt => {const val = evt.target.checked; this.setState(prevState => ({...prevState, param: {...prevState.param, optional: val}}));}}
          />
          <label style={{display: "contents"}} for="Input_Optional">Parameter is optional (if enabled, all parameters below will be applied just when the parameter is selected by the user)</label>
        </div>

<div class="tablediv">

      <div>Assign services and override prices</div>
      <table className='table table-striped' aria-labelledby="tabelLabel">
        <thead>
          <tr>
            <th>Id</th>
            <th>Name</th>
            <th>Price</th>
            <th>MinTime</th>
            <th>MaxTime</th>
            <th>Editable</th>
          </tr>
        </thead>
        <tbody>
          {this.state.services.filter(service => service.assigned).map(service =>
            <tr key={service.id} onClick={() => this.selectParmaService(service)} class={this.state.paramservice?.id === service.id?'react-calendar__tile--active':''}>
              <td>{service.id}</td>
              <td>{service.name}</td>
              <td>{service.price}</td>
              <td>{service.minTime}</td>
              <td>{service.maxTime}</td>
              <td>{service.timeEditable ? '+' : ''}</td>
            </tr>
          )}
        </tbody>
      </table>

      </div>
              <div class="form-group">
          <label for="Input_BookingProfile">Resource booking profile</label>
          <select class="form-control" id="Input_BookingProfile" name="Input.BookingProfile"
            value={val.profileId ? val.profileId.toString() : ''}
            onChange={evt => {const val = evt.target.value; this.setState(prevState => ({...prevState, resource: {...prevState.param, profileId: parseInt(val)}}));}}>
              <option value="0"></option>
              {this.state.profiles.map(profile => <option value={profile.id}>{profile.name}</option>)}
          </select>
        </div>

        <div class="form-group">
          <label for="Input_ServicePrice">Service price</label>
          <input class="form-control" type="text" id="Input_ServicePrice" name="Input.ServicePrice"
            value={val.price !== undefined ? val.price : '0'}
            onChange={evt => {const val = evt.target.value; this.setState(prevState => ({...prevState, param: {...prevState.param, price: val}}));}}
          />
        </div>
        <div class="form-group">
          <label for="Input_ServiceMinTime">Service minimum duration in hours</label>
          <input class="form-control" type="text" id="Input_ServiceMinTime" name="Input.ServiceMinTime"
            value={val.minTime !== undefined ? val.minTime : '0'}
            onChange={evt => {const val = evt.target.value; this.setState(prevState => ({...prevState, service: {...prevState.param, minTime: val}}));}}
          />
        </div>
        <div class="form-group">
          <label for="Input_ServiceMaxTime">Service maximum duration in hours</label>
          <input class="form-control" type="text" id="Input_ServiceMaxTime" name="Input.ServiceMaxTime"
            value={val.maxTime !== undefined ? val.maxTime : '8760'}
            onChange={evt => {const val = evt.target.value; this.setState(prevState => ({...prevState, service: {...prevState.param, maxTime: val}}));}}
          />
        </div>
        <div class="form-group">
          <label for="Input_BookingInterval">Service booking interval</label>
          <select class="form-control" id="Input_BookingInterval" name="Input.BookingInterval"
            value={val.bookingInterval ? val.bookingInterval.toString() : ''}
            onChange={evt => {const val = evt.target.value; this.setState(prevState => ({...prevState, service: {...prevState.param, bookingInterval: val}}));}}>
              <option value="1">1 min</option>
              <option value="2">5 min</option>
              <option value="3">1 hour</option>
              <option value="4">1 day</option>
          </select>
        </div>
        <div class="form-group">
          <label for="Input_PartialBooking">Partial booking settings</label>
          <select class="form-control" id="Input_PartialBooking" name="Input.PartialBooking"
            value={val.partialBooking ? val.partialBooking.toString() : 'null'}
            onChange={evt => {const val = evt.target.value; this.setState(prevState => ({...prevState, service: {...prevState.param, partialBooking: val === 'null' ? null : val}}));}}>
              <option value="null">Off</option>
              <option value="2">2 members</option>
              <option value="3">3 members</option>
              <option value="4">4 members</option>
              <option value="5">5 members</option>
              <option value="6">6 members</option>
              <option value="7">7 members</option>
              <option value="8">8 members</option>
              <option value="9">9 members</option>
              <option value="10">10 members</option>
          </select>
        </div>
        <input style={{marginTop: "5px"}} class="btn btn-primary" type="button" value="Save" id="Button_Save" onClick={() => this.handleSaveFilter(val)}/>
      </>
    );
  }

  renderResourceParams() {
    return (
      <div class="tablediv">
        <div>Parameters for filters</div>
        {this.state.filters.map(res =>
          <div>{res.name?<label>{res.name}</label>:<></>}<table class="table-filter2"><tr>{res.items.map(p => 
            <>
              <td key={p.id} onClick={() => this.addFilter(p.id, res.id)} className={this.state.resource.params.includes(p.id)?'react-calendar__tile--active filtername':'filtername'}>{p.name}</td>
              <Popup
                className="popup-info"
                trigger={open => <td class="filteropt"></td>}
                position="bottom center"
                closeOnDocumentClick>{() => this.renderParamOptions(res, p)}</Popup>
            </>
          )}{this.state.curparamgroup === res.id ? 
            <td><input style={{border: "0"}} type="text" id="Input_GroupValue" name="Input.GroupValue"
              value={this.state.newgroupvalue !== undefined ? this.state.newgroupvalue : ''}
              onChange={evt => {const val = evt.target.value; this.setState(prevState => ({...prevState, newgroupvalue: val}));}}
            /></td>
            : <></>}
            {this.state.curparamgroup === res.id ? <td onClick={() => this.saveGroupValue(res.id)}>&#10004;</td> : <td onClick={() => this.setState(prevState => ({...prevState, curparamgroup: res.id}))}>+</td>}
            </tr></table></div>
        )}
        <div>
          <label for="Input.GroupName">Create new group</label>
          <input style={{margin: "8px 0px 4px 5px"}} class="form-control form-control-inline" type="text" id="Input_GroupName" name="Input.GroupName"
            value={this.state.newgroupname !== undefined ? this.state.newgroupname : ''}
            onChange={evt => {const val = evt.target.value; this.setState(prevState => ({...prevState, newgroupname: val}));}}
          />
          <input style={{margin: "8px 0px 4px 0px", border: "1px solid #d3d3d3"}} class="btn" type="button" value="&#10004;" id="Button_New" onClick={this.handleNewGroup}/>
        </div>
      </div>
    );
  }

  render() {
    let contents = this.state.loading
      ? <p><em>Loading...</em></p>
      : this.renderResourcesTable();

    let serviceContents = !this.state.resource?.id
      ? <></>
      : this.renderServicesTable();

    let paramsContents = !this.state.resource?.id
      ? <></>
      : this.renderResourceParams();

    return (
      <div class="sidenav-container-div">
        <ConfigMenu {...this.props} companyId={this.state.companyId} selected="resources" />
        <div>
        {this.state.resource?this.renderRightPanel():<></>}
        <div class="headerdiv"><h4 id="tabelLabel"><FormattedMessage id="config_resources"/></h4></div>
        <div class="centerpanel"><div><FormattedMessage id="resources_list"/></div>
        {contents}
        {this.state.resource===null?<></>:this.renderResourcesParams()}
        {paramsContents} 
        {serviceContents}
        </div></div>
      </div>
    );
  }

  async populateResourcesData(companyId) {
    const token = await authService.getAccessToken();
    const response = await fetch(`{{mainApiUrl}}api/companies/${companyId}/resources`, {
      headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
    });
    const data = await response.json();
    this.setState(prevState => ({...prevState, resources: data, loading: false}));
    this.populateProfilesData(companyId);
  }

  async populateServicesData(companyId) {
    const token = await authService.getAccessToken();
    const response = await fetch(`{{mainApiUrl}}api/companies/${companyId}/${this.state.resource.id}/services`, {
      headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
    });
    const data = await response.json();
    this.setState(prevState => ({...prevState, services: data, loading: false}));
  }

  async populateCompaniesData() {
    const token = await authService.getAccessToken();
    const response = await fetch(`{{mainApiUrl}}api/companies/admin`, {
      headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
    });
    const data = await response.json();
    this.setState(prevState => ({...prevState, companies: data}));
    if (this.state.companies.length > 0)
    {
        this.setState(prevState => ({...prevState, companyId: this.state.companies[0].id}));
        this.populateResourcesData(this.state.companyId);
        this.populateFiltersData();
    }
  }

  async populateFiltersData(serviceId) {
    const token = await authService.getAccessToken();
    const url = `{{mainApiUrl}}api/companies/resourceparamgroups/${this.state.companyId}`;
    const response = await fetch(url, {
      headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
    });
    const data = await response.json();
    this.setState(prevState => ({...prevState, filters: data}));
  }

  async populateProfilesData(companyId) {
    const token = await authService.getAccessToken();
    const response = await fetch(`{{mainApiUrl}}api/companies/${companyId}/profiles`, {
      headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
    });
    const data = await response.json();
    this.setState(prevState => ({...prevState, profiles: data, loading: false}));
  }
}
